import Vue from 'vue';
import VueRouter from 'vue-router';
import FlowChart from '../views/Editor';
import Sequence from '../views/Sequence';

Vue.use(VueRouter);

const routes = [
    {
        path: '/flow-chart/',
        name: 'Home',
        component: FlowChart
    },
    {
        path: '/sequence/',
        name: 'Sequence',
        component: Sequence
    },
    {
        path: '/about',
        name: 'About',
        // route level code-splitting
        // this generates a separate chunk (about.[hash].js) for this route
        // which is lazy-loaded when the route is visited.
        component: () => import(/* webpackChunkName: "about" */ '../views/About.vue')
    }
];

const router = new VueRouter({
    mode: 'history',
    base: process.env.BASE_URL,
    routes
});

export default router;
